import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    CodeViewerFoldButtonDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    getHitArea
} from "../../../../helpers/theme/control";
import {
    getCodeTextStyle
} from "../../stylesheet";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    foldButton: {
        justifyContent: "center",
        alignItems: "center",
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    foldSurface: {
        justifyContent: "center",
        alignItems: "center"
    }
});

export const useStyles = ({
    isFocusVisible,
    shapeConfigs,
    touchTargets,
    pointerType,
    typography,
    iconSizes,
    radiuses,
    borders,
    colors,
    size
}: CodeViewerFoldButtonDynamicStyleType) => {
    const codeTextStyle = getCodeTextStyle({
        typography,
        size
    });

    const hitArea = getHitArea({
        visualSize: iconSizes.small,
        touchTargets,
        pointerType
    });

    const styles = {
        container: {
            marginVertical: ((codeTextStyle.lineHeight ?? 0) - hitArea.minHeight) / 2,
            marginHorizontal: (iconSizes.medium - hitArea.minWidth) / 2,
            height: hitArea.minHeight,
            width: hitArea.minWidth
        } as Mutable<ViewStyle>,
        surface: {
            ...getCornerStyle({
                radius: radiuses.xs,
                shapeConfigs
            }),
            height: iconSizes.small,
            width: iconSizes.small
        } as Mutable<ViewStyle>
    };

    Object.assign(styles.surface, getFocusRingStyle({
        colorKey: "default",
        isFocusVisible,
        borders,
        colors
    }));

    return styles;
};

export default stylesheet;
